export default __webpack_public_path__ + "static/media/1772.b5d31f53.png";